export default function WhiteLightSplittingVisual() {
  return <div>white light splitting works</div>;
}